module.exports = __webpack_public_path__ + "img/eventos.78101766.png";